import { sourceSansPro } from '@cambridgeassessment/cambridge-ui/build/abstracts/constants';
import styled from 'styled-components';

export const StyledConsortiumCentres = styled.div`
  font-family: ${sourceSansPro};
  padding-top: 16px;
  font-size: 14px;
  line-height: 1.36;
  display: flex;
  align-items: center;
`;

export const StyledCentresLinks = styled.div`
  padding-left: 4px;

  a {
    font-size: 14px;
  }
`;

export const StyledConsortiumGroupIcon = styled.div`
  padding-right: 8px;
  display: flex;
`;

export const StyledFlexContainer = styled.div`
  display: flex;
`;
